class ProductExclusiveOffers {
  constructor() {
    this.openTooltip = null;
    this.openTooltipButton = null;
    this.init();
  }

  init = () => {
    document.addEventListener('click', this.handleClick);
    document.addEventListener('keydown', this.handleKeydown);
    window.addEventListener('resize', this.closeTooltip);
    window.addEventListener('scroll', this.closeTooltip, true);
  };

  handleClick = (event) => {
    const infoButton = event.target.closest('.exclusive-offer-card__info-btn');
    if (infoButton) {
      event.stopPropagation();
      this.toggleTooltip(infoButton);
      return;
    }

    const copyButton = event.target.closest('.exclusive-offer-card__copy-btn');
    if (copyButton) {
      const code = copyButton.dataset.code;
      if (code) this.copyCode(code, copyButton);
      return;
    }

    if (!event.target.closest('.exclusive-offer-card__tooltip')) {
      this.closeTooltip();
    }
  };

  handleKeydown = (event) => {
    if (event.key === 'Escape') this.closeTooltip();
  };

  toggleTooltip = (button) => {
    const wrap = button.closest('.exclusive-offer-card__info-wrap');
    const tooltip = wrap ? wrap.querySelector('.exclusive-offer-card__tooltip') : null;
    if (!tooltip) return;

    if (tooltip === this.openTooltip) {
      this.closeTooltip();
      return;
    }

    this.closeTooltip();

    tooltip.hidden = false;
    button.setAttribute('aria-expanded', 'true');

    const buttonRect = button.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const gap = 10;

    let left = buttonRect.left + buttonRect.width / 2 - tooltipRect.width / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - tooltipRect.width - 8));

    let top = buttonRect.top - tooltipRect.height - gap;
    if (top < 8) {
      top = buttonRect.bottom + gap;
    }

    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;

    this.openTooltip = tooltip;
    this.openTooltipButton = button;
  };

  closeTooltip = () => {
    if (!this.openTooltip) return;

    this.openTooltip.hidden = true;
    if (this.openTooltipButton) this.openTooltipButton.setAttribute('aria-expanded', 'false');

    this.openTooltip = null;
    this.openTooltipButton = null;
  };

  copyCode = (code, button) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(code)
        .then(() => this.showCopied(button))
        .catch(() => this.fallbackCopy(code, button));
    } else {
      this.fallbackCopy(code, button);
    }
  };

  fallbackCopy = (code, button) => {
    const textarea = document.createElement('textarea');
    textarea.value = code;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      document.execCommand('copy');
      this.showCopied(button);
    } catch (err) {
      console.error('Failed to copy code', err);
    }

    document.body.removeChild(textarea);
  };

  showCopied = (button) => {
    const label = button.querySelector('.exclusive-offer-card__copy-label');
    const originalText = label ? label.textContent : '';
    const copiedText = button.dataset.copiedText || 'Copied!';

    button.classList.add('is-copied');
    if (label) label.textContent = copiedText;

    clearTimeout(button._exclusiveOfferCopyTimeout);
    button._exclusiveOfferCopyTimeout = setTimeout(() => {
      button.classList.remove('is-copied');
      if (label) label.textContent = originalText;
    }, 2000);
  };
}

window.ProductExclusiveOffers = function () {
  new ProductExclusiveOffers();
};
window.ProductExclusiveOffers();
